import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { motion } from "framer-motion";
import "./HomePage.css";

const HomePage = () => {
  const [dataMap, setDataMap] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetch("/dataMap.json")
      .then((res) => res.json())
      .then((data) => setDataMap(data))
      .catch((err) => console.error("Failed to load dataMap:", err));
  }, []);

  if (!dataMap) return null;

  const currentYear = dataMap.current.replace("/", "");
  const archiveEntries = Object.entries(dataMap.archives);

  return (
    <div className="home-container">
      <div className="home-bg-hearts">
        {[...Array(12)].map((_, i) => (
          <span key={i} className="floating-heart" style={{ "--i": i }}>
            ♥
          </span>
        ))}
      </div>

      <motion.div
        className="home-content"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <h1 className="home-title">
          Welcome to Our <span className="highlight">Valentines</span> Website
        </h1>
        <p className="home-subtitle">A little corner of the internet just for us 💕</p>

        <div className="year-cards">
          <motion.div
            className="year-card current"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.97 }}
            onClick={() => navigate(dataMap.current)}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.5 }}
          >
            <span className="year-badge">✨ This Year</span>
            <span className="year-number">{currentYear}</span>
            <span className="year-arrow">→</span>
          </motion.div>

          {archiveEntries.length > 0 && (
            <div className="archives-section">
              <h2 className="archives-heading">Previous Years</h2>
              <div className="archives-grid">
                {archiveEntries.map(([year, path], index) => (
                  <motion.div
                    key={year}
                    className="year-card archive"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.97 }}
                    onClick={() => navigate(`/${path}`)}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.6 + index * 0.15, duration: 0.5 }}
                  >
                    <span className="year-badge archive-badge">📁 Archive</span>
                    <span className="year-number">{year}</span>
                    <span className="year-arrow">→</span>
                  </motion.div>
                ))}
              </div>
            </div>
          )}
        </div>
      </motion.div>
    </div>
  );
};

export default HomePage;
